import {PureComponent} from "react";
import {withCookies} from "react-cookie";

const platformIP = process.env.REACT_APP_PLATFORM_IP;
const platformPort = process.env.REACT_APP_PLATFORM_PORT;

class RedirectPlatform extends PureComponent {

    constructor(props) {
        super(props);
        this.clearCookies = this.clearCookies.bind(this);
    }

    componentDidMount() {
        if (this.props.match.params.action === "logout") {
            this.clearCookies();
        }
        window.location.replace(platformIP + ":" + platformPort + "/" + (this.props.match.params.action === "platform" ? "" : "logout"));
    }

    clearCookies() {
        Object.keys(this.props.cookies.getAll()).map((key) => {
            this.props.cookies.remove(key);
            return true;
        });
    }

    render() {
        return null;
    }
}

export default withCookies(RedirectPlatform);
